import { Component, ElementRef, Input, OnInit, Renderer2, inject } from '@angular/core';
import { ShapeTypes } from './shape-types.enum';

@Component({
    selector: 'shape-divider',
    templateUrl: './shape-divider.component.html',
    styleUrls: ['./shape-divider.component.scss'],
    standalone: true,
})
export class ShapeDividerComponent implements OnInit {
    private _elRef = inject(ElementRef);
    private _renderer = inject(Renderer2);

    @Input() shapeType: ShapeTypes | undefined; // optional: Defines the type of shape divider, default is Waves
    @Input() isFlip: boolean | undefined; // optional: Defines the diraction of the shape divider
    @Input() isTop: boolean | undefined; // optional: Defines the position of the shape divider
    @Input() shapeFill: string | undefined; // optional: color for bgcolor. default is #fff
    @Input() shapeHeight: string | undefined; // optional set height the svg. use 2em, 24px, 3vh ect. default is 50px
    @Input() shapeWidth: string | undefined; // optional set width the svg. use 100%, 200%, 300% ect. default is 100%

    public shapeTypes = ShapeTypes;
    public shraePrefix: string = '--shape-';
    ngOnInit(): void {
        this._renderer.setAttribute(
            this._elRef.nativeElement,
            'style',
            `${this.shraePrefix}height: ${this.shapeHeight || '50px'}; ${this.shraePrefix}fill: ${this.shapeFill || '#fff'}; ${this.shraePrefix}width: ${
                this.shapeWidth || '100%'
            };`,
        );
    }
}
